<template>
  <div class="hello">
    <!--<HomeImg></HomeImg>-->
    <home></home>
  </div>
</template>

<script>
  import HomeImg from '../components/image/image'
  import home from '../components/home/home'

  export default {
    name: 'HelloWorld',
    components: {
      home,
      HomeImg
    },
    data() {
      return {}
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  @import url('../assets/css/hearder.css');

  h1,
  h2 {
    font-weight: normal;
  }

  ul {
    list-style-type: none;
    padding: 0;
  }

  li {
    display: inline-block;
    margin: 0 10px;
  }

  a {
    color: #42b983;
  }
</style>



// WEBPACK FOOTER //
// src/components/HelloWorld.vue